const BRIDGE_PROTOCOL_VERSION = 1;

interface IReactNativeWebView {
  postMessage: (message: string) => void;
}

export const NativeAppMessageType = {
  AuthUnauthorized: "auth:unauthorized",
} as const;

export type NativeAppMessageType = (typeof NativeAppMessageType)[keyof typeof NativeAppMessageType];

/**
 * Posts a message to the native shell hosting this WebView, if there is one.
 * @param type message type the shell switches on
 * @param payload additional fields merged into the message payload
 * @returns true when a shell was present to receive the message
 */
export const postToNativeShell = (
  type: NativeAppMessageType,
  payload: Record<string, unknown> = {}
): boolean => {
  const shell = (window as unknown as { ReactNativeWebView?: IReactNativeWebView }).ReactNativeWebView;
  if (!shell) {
    return false;
  }

  try {
    shell.postMessage(JSON.stringify({ v: BRIDGE_PROTOCOL_VERSION, payload: { type, ...payload } }));
    return true;
  } catch (e) {
    console.error("Failed to post message to the native shell", e);
    return false;
  }
};
